import React, { useEffect, useState, useContext } from "react";
import Input from "../input/Input";
import styles from "./ModalAddData.module.css";

import { CurrentUserContext } from "../../../App";

//ของแอดมิน หน้า managewebsite
function ModalAddData({
  onSubmit,
  onClose,
  titlename,
  defaultTitle,
  defaultDetail,
  showDetail,
  labelInputName,
  labelTextAreaName,
}) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    if (showDetail) {
      setTitle(defaultTitle);
      setDetail(defaultDetail);
    }
  }, [showDetail, defaultTitle, defaultDetail]);

  const onSaveCallback = () => {
    if (title === "") {
      setIsMessage({
        type: "warning",
        data: `กรุณาใส่ ${labelInputName ? labelInputName : "หัวข้อ"}`,
      });
      return;
    }
    if (detail === "") {
      setIsMessage({
        type: "warning",
        data: `กรุณาใส่ ${labelTextAreaName ? labelTextAreaName : "รายละเอียด"}`,
      });
      return;
    } else {
      onSubmit({
        title,
        title,
        detail,
        detail,
      });
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modalController}>
        <div className={styles.closeButton}>
          <img
            onClick={() => {
              onClose();
            }}
            src={require("../../../asset/icon/close-icon.svg").default}
          ></img>
        </div>
        <div className={styles.contentModal}>
          <div className="text-xl text-center">{titlename}</div>
          <div className={styles.line__modal}></div>

          <div className="text-xl text-[#A2B5BC]">
            {labelInputName ? labelInputName : "หัวข้อ"}
          </div>
          <input
            disabled={showDetail}
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            className="border-2 border-solid border-[#A2B5BC] rounded-xl text-[#A2B5BC] p-5 focus:outline-none mt-1 mb-4 w-full"
          ></input>
          <div className="text-xl text-[#A2B5BC]">
            {labelTextAreaName ? labelTextAreaName : "รายละเอียด"}
          </div>
          <textarea
            disabled={showDetail}
            value={detail}
            onChange={(e) => {
              setDetail(e.target.value);
            }}
            className="border-2 border-solid border-[#A2B5BC] rounded-xl text-[#A2B5BC] p-5 focus:outline-none mt-1 w-full h-40"
          ></textarea>

          {!showDetail ? (
            <div className="flex justify-center my-6">
              <button
                onClick={() => {
                  onSaveCallback();
                }}
                className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
              >
                บันทึก
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ModalAddData;
